import { Box, Button } from "@mui/material";
import React, { useState } from "react";
import { FilterOption } from "..";

type ListingFiltersProps = {
  filters: FilterOption[];
  onFilterChange?: (active: string) => void;
};

const ListingFilters: React.FC<ListingFiltersProps> = ({ filters, onFilterChange }) => {
  const [active, setActive] = useState<string>(filters[0].label);

  const handleClick = (filter: FilterOption) => {
    setActive(filter.label);
    onFilterChange?.(filter.label);
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      flexWrap="wrap"
      gap={1.5}
      mb={2}
    >
      {filters.map((filter) => (
        <Button
          key={filter.label}
          onClick={() => handleClick(filter)}
          variant={active === filter.label ? "contained" : "outlined"}
          startIcon={<filter.icon/>}
          sx={{
            borderRadius: "20px",
            textTransform: "none",
            fontSize: "14px",
            fontWeight: 500,
            px: 2.5,
            py: 0.5,
            color: active === filter.label ? "#fff" : "#2F4F2F",
            bgcolor: active === filter.label ? "#2F4F2F" : "#F5F9E9",
            borderColor: active === filter.label ? "#2F4F2F" : "#DADADA",
            "&:hover": {
              bgcolor: active === filter.label ? "#244024" : "#E8F2D9",
              borderColor: active === filter.label ? "#244024" : "#C6D7B0",
            },
          }}
        >
          {filter.label}
        </Button>
      ))}
    </Box>
  );
};

export default ListingFilters;
